import { Accordion } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import AccessAdmin from "./access_admin";

const NAV_LINK_CLASS = ({ isActive }) =>
  isActive
    ? "text-decoration-none fw-bold active"
    : "text-decoration-none fw-bold";

const MENU_SECTIONS = [
  {
    title: "Trang chủ",
    icon: "home",
    items: [{ to: "/", label: "Dashboard", icon: "dashboard" }],
  },
  {
    title: "Tạo bill ngân hàng",
    icon: "section",
    items: [
      { to: "/transfers", label: "Bill chuyển khoản" },
      { to: "/transactions", label: "Bill biến động" },
      { to: "/balances", label: "Bill số dư" },
      { to: "/sms", label: "SMS Banking" },
      { to: "/sms-notifications", label: "Thông báo SMS Banking" },
    ],
  },
  // {
  //   title: "Yêu cầu rút tiền",
  //   icon: "section",
  //   items: [
  //     { to: "/withdrawal-request", label: "Yêu cầu rút tiền RR88" },
  //     { to: "/withdrawal_request_XX88", label: "Yêu cầu rút tiền XX88" },
  //     { to: "/withdrawal_request_MM88", label: "Yêu cầu rút tiền MM88" },
  //     { to: "/withdrawal_request_gg88", label: "Yêu cầu rút tiền GG88" },
  //     { to: "/withdrawal_request_llwin", label: "Yêu cầu rút tiền LLWIN" },
  //   ],
  // },
  // {
  //   title: "Lịch sử giao dịch",
  //   icon: "section",
  //   items: [
  //     { to: "/transaction-history", label: "Lịch sử giao dịch RR88" },
  //     { to: "/transaction-historyXX88", label: "Lịch sử giao dịch XX88" },
  //     { to: "/transaction_historyMM88", label: "Lịch sử giao dịch MM88" },
  //   ],
  // },
  // {
  //   title: "Màn hình trang chủ",
  //   icon: "section",
  //   items: [
  //     { to: "/home-screen", label: "Trang chủ RR88" },
  //     { to: "/home-screenXX88", label: "Trang chủ XX88" },
  //     { to: "/home-screenMM88", label: "Trang chủ MM88" },
  //     { to: "/home-screenGG88", label: "Trang chủ GG88" },
  //     { to: "/home-screenLLWIN", label: "Trang chủ LLWIN" },
  //   ],
  // },
  // {
  //   title: "Màn hình game",
  //   icon: "section",
  //   items: [
  //     { to: "/game-screen", label: "Màn hình game RR88" },
  //     { to: "/game-screenXX88", label: "Màn hình game XX88" },
  //     { to: "/game-screenMM88", label: "Màn hình game MM88" },
  //     { to: "/game-screenGG88", label: "Màn hình game GG88" },
  //     { to: "/game-screenLLWIN", label: "Màn hình game LLWIN" },
  //   ],
  // },
  // {
  //   title: "Lịch sử rút tiền",
  //   icon: "section",
  //   items: [
  //     { to: "/withdrawal-history", label: "Lịch sử rút tiền RR88" },
  //     { to: "/withdrawal-usdt-history", label: "Lịch sử rút USDT RR88" },
  //     { to: "/withdrawal_historyXX88", label: "Lịch sử rút tiền XX88" },
  //     { to: "/withdrawal_usdt_historyXX88", label: "Lịch sử rút USDT XX88" },
  //     { to: "/withdrawal_historyMM88", label: "Lịch sử rút tiền MM88" },
  //     { to: "/withdrawal_usdt_historyMM88", label: "Lịch sử rút USDT MM88" },
  //     { to: "/withdrawal-historyGG88", label: "Lịch sử rút tiền GG88" },
  //     { to: "/withdrawal_historyLLWIN", label: "Lịch sử rút tiền LLWIN" },
  //   ],
  // },
  // {
  //   title: "Lịch sử hoàn trả",
  //   icon: "section",
  //   items: [
  //     { to: "/refund-history", label: "Lịch sử hoàn trả RR88" },
  //     { to: "/refund-historyXX88", label: "Lịch sử hoàn trả XX88" },
  //     { to: "/refund_history_MM88", label: "Lịch sử hoàn trả MM88" },
  //   ],
  // },
  // {
  //   title: "Lịch sử nạp tiền",
  //   icon: "section",
  //   items: [
  //     { to: "/deposit-history", label: "Lịch sử nạp tiền RR88" },
  //     { to: "/deposit-history-xx88", label: "Lịch sử nạp tiền XX88" },
  //     { to: "/deposit-history-MM88", label: "Lịch sử nạp tiền MM88" },
  //     { to: "/deposit-history-GG88", label: "Lịch sử nạp tiền GG88" },
  //     { to: "/deposit-history-llwin", label: "Lịch sử nạp tiền LLWIN" },
  //   ],
  // },
  // {
  //   title: "Lịch sử đặt cược",
  //   icon: "section",
  //   items: [{ to: "/bet-history-mm88", label: "Lịch sử đặt cược MM88" }],
  // },
];

function MenuIcon({ type }) {
  if (type === "home") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-house-door"
        viewBox="0 0 16 16"
      >
        <path d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4z" />
      </svg>
    );
  }

  if (type === "dashboard") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-speedometer2"
        viewBox="0 0 16 16"
      >
        <path d="M8 4a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-1 0V4.5A.5.5 0 0 1 8 4M3.732 5.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707M2 10a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 10m9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5m.754-4.246a.39.39 0 0 0-.527-.02L7.547 9.31a.91.91 0 1 0 1.302 1.258l3.434-4.297a.39.39 0 0 0-.029-.518z" />
        <path
          fillRule="evenodd"
          d="M0 10a8 8 0 1 1 15.547 2.661c-.442 1.253-1.845 1.602-2.932 1.25C11.309 13.488 9.475 13 8 13c-1.474 0-3.31.488-4.615.911-1.087.352-2.49.003-2.932-1.25A8 8 0 0 1 0 10m8-7a7 7 0 0 0-6.603 9.329c.203.575.923.876 1.68.63C4.397 12.533 6.358 12 8 12s3.604.532 4.923.96c.757.245 1.477-.056 1.68-.631A7 7 0 0 0 8 3"
        />
      </svg>
    );
  }

  if (type === "section") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-chevron-bar-right"
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          d="M4.146 3.646a.5.5 0 0 0 0 .708L7.793 8l-3.647 3.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708 0M11.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5"
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-hash"
      viewBox="0 0 16 16"
    >
      <path d="M8.39 12.648a1 1 0 0 0-.015.18c0 .305.21.508.5.508.266 0 .492-.172.555-.477l.554-2.703h1.204c.421 0 .617-.234.617-.547 0-.312-.188-.53-.617-.53h-.985l.516-2.524h1.265c.43 0 .618-.227.618-.547 0-.313-.188-.524-.618-.524h-1.046l.476-2.304a1 1 0 0 0 .016-.164.51.51 0 0 0-.516-.516.54.54 0 0 0-.539.43l-.523 2.554H7.617l.477-2.304c.008-.04.015-.118.015-.164a.51.51 0 0 0-.523-.516.54.54 0 0 0-.531.43L6.53 5.484H5.414c-.43 0-.617.22-.617.532s.187.539.617.539h.906l-.515 2.523H4.609c-.421 0-.609.219-.609.531s.188.547.61.547h.976l-.516 2.492c-.008.04-.015.125-.015.18 0 .305.21.508.5.508.265 0 .492-.172.554-.477l.555-2.703h2.242zm-1-6.109h2.266l-.515 2.563H6.859l.532-2.563z" />
    </svg>
  );
}

function MenuItem({ item, index }) {
  return (
    <div className={index === 0 ? undefined : "mt-3"}>
      <NavLink to={item.to} className={NAV_LINK_CLASS}>
        <MenuIcon type={item.icon || "item"} />
        <span className="ms-2 text-uppercase">{item.label}</span>
      </NavLink>
    </div>
  );
}

function MenuSection({ section, eventKey }) {
  return (
    <Accordion.Item className="border-0" eventKey={eventKey}>
      <Accordion.Header>
        <MenuIcon type={section.icon} />
        <span className="fw-bold ms-2 text-uppercase">{section.title}</span>
      </Accordion.Header>
      <Accordion.Body>
        {section.items.map((item, index) => (
          <MenuItem
            key={`${item.to}-${item.label}`}
            item={item}
            index={index}
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}

export default function Menu() {
  return (
    <div className="menu-links">
      <Accordion defaultActiveKey="bank-bills">
        {MENU_SECTIONS.map((section, index) => (
          <MenuSection
            key={`${section.title}-${index}`}
            section={section}
            eventKey={section.title === "Tạo bill ngân hàng" ? "bank-bills" : String(index)}
          />
        ))}
      </Accordion>
      <AccessAdmin />
    </div>
  );
}
